import http from '@plugin/axios'
import routerMap from '@/plugin/router/router'
import store from '@plugin/store'
import router from '@plugin/router'

interface SignInfo {
  token: string;
  settingDisplayNo: string;
  roleId: number;
  remoteBarcode: string;
  officeType: string;
  empowerFlag: boolean;
}
// 登录
export function signIn(data: object) {
  return http<SignInfo>({
    url: '/loginByUserName',
    data
  })
}
// 退出登录
export function signOut() {
  return http({
    url: '/loginOut'
  })
}
// 获取全部菜单
export function getRoutesAndMenus<T>(matchedName = 'Root.Purchaser') {
  return new Promise<T>(resolve => {
    const menu = routerMap.get(matchedName)
    if (!menu) return
    menu().then(res => {
      resolve(res.data)
    }).catch(() => {
      resolve(null as never)
    })
  })
}

// 获取用户信息
export function getCurrentUser() {
  return http({
    url: '/sysUser/getCurrentUser'
  })
}

// 获取最近操作和固定菜单
export function getQuickRecordList(): Promise<string> {
  return http<{ quickRecord: string }>({
    url: '/srmQuickRecord/getQuickRecordList'
  }).then(res => res.quickRecord)
}

// 更新最近操作和固定菜单
export function saveOrUpdateQuickRecord(data: string) {
  return http({
    url: '/srmQuickRecord/saveOrUpdateQuickRecord',
    data: {
      quickRecord: data
    },
    loading: false
  })
}

// 用来测试tab组件的接口
export function getPurchaseHeadStatusCount() {
  return http({
    url: '/srmPurchaseHead/getPurchaseHeadStatusCount',
    baseURL: process.env.VUE_APP_PURCHASE_API
  })
}

export function downloadFile(url: string, data: any = {}, fileName?: string, type = 'post') {
  const token = store.getters.token
  const xhr = new XMLHttpRequest()
  xhr.open(type, url, true)
  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8')
  xhr.setRequestHeader('Authentication-Info', token)
  xhr.responseType = 'blob'
  xhr.onload = function() {
    if (this.status === 200) {
      const blob = this.response
      const a = document.createElement('a')
      a.href = window.URL.createObjectURL(blob)
      if (fileName) {
        a.download = fileName
      }
      a.click()
    }
  }
  xhr.send(JSON.stringify(data))
}

// 获取所有语言别
export function getAllZlLanguage() {
  /*  return http({
    url: '/zlLanguage/getAllZlLanguage',
    method: 'post'
  }) */
  return Promise.resolve([{ 'id': 1, 'languageCode': 'zh_CN', 'description': '简体中文' }, { 'id': 2, 'languageCode': 'zh_TW', 'description': '繁體中文' }, { 'id': 3, 'languageCode': 'en_US', 'description': 'English' }])
}

// 获取自定义字段
export function getSysFrameDefineListByModule(name: string) {
  const route: any = router.resolve({ name }).route
  if (!route.meta.menuNo) return Promise.resolve([])
  return http({
    url: '/sysFrameDefine/getSysFrameDefineListByModule',
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'post',
    data: {
      module: route.meta.menuNo
    },
    loading: true
  })
}

// 获取安装配置信息
export function getMainPage() {
  return http({
    url: '/installGuide/getMainPage'
  })
}

// 获取邮箱验证码
export function getMailVerificationCode(invitationEmail: string) {
  return http({
    url: '/registered/getMailVerificationCode',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: { invitationEmail }
  })
}

// 获取注册协议信息
export function getSrmSupplierProtocolList(type = 1) {
  return http({
    url: '/supplierProtocol/getSrmSupplierProtocolList',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: { type }
  })
}

export function uploadSrmSupplierRegisteredFile(data: object) {
  return http({
    url: '/supplierRegisteredFile/uploadSrmSupplierRegisteredFile',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data
  })
}
